angular.module('quattro.bmbo.index', [
    'quattro.core.filters',
    'quattro.core.user',
    'quattro.core.alert.service',
])
    .controller('IndexController', function ($location, $filter, alertService, userService) {

        var defaultRoute = '';

        var userName = userService.get('userName');
        var userLevel = userService.get('userLevel');

        switch (userLevel) {
            case undefined:
                defaultRoute = '/login';
                break;
            case 'admin':
                defaultRoute = '/dashboard';
                break;
            case 'account':
                defaultRoute = '/account=' + userName;
                break;
            default:
                defaultRoute = '/login';
        }

        $location.path(defaultRoute);
        $location.replace();

    });
